import { render } from "./DefSlideRight.vue?vue&type=template&id=be7f7c12&scoped=true"
import script from "./DefSlideRight.vue?vue&type=script&lang=js"
export * from "./DefSlideRight.vue?vue&type=script&lang=js"

import "./DefSlideRight.vue?vue&type=style&index=0&id=be7f7c12&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be7f7c12"]])

export default __exports__